export const MAX_WORD_LENGTH = 5
export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 350
export const ReactGaKey = 'G-Z390D8TKR8'
// export const GAME_LOST_INFO_DELAY = (MAX_WORD_LENGTH + 1) * REVEAL_TIME_MS
// export const GAME_LOST_INFO_DELAY = 4 * REVEAL_TIME_MS
